import variantAPI from '@/api/products/variants'

export const getVariant = ({ commit, dispatch }, productId) => {
  commit('setProductIdVariant', productId)
  dispatch('getVariantAttributes')
  dispatch('getProductVariants')
}

export const getProductVariants = ({ commit, state }) => {
  let param = {
    productId: state.productId,
    search: state.search
  }
  variantAPI.getProductVariants(param, results => {
    if (results.data.data) {
      commit('setProductVariants', results)
    } else {
      commit('setProductVariants', [])
    }
  })
}

export const getVariantAttributes = ({ commit, state }) => {
  variantAPI.getVariantAttrubutes(state.productId, results => {
    if (results.data.data) {
      commit('setVariantAttributes', results.data.data.product_attribute)
    } else {
      commit('setVariantAttributes', [])
    }
  })
}

export const addVariantAttributes = ({ commit, state }, attributes) => {
  return new Promise((resolve, reject) => {
    let attributeLocal = []
    attributes.forEach((element, index) => {
      if (element.attribute !== '' && element.value.length > 0) {
        attributeLocal[index] = element
      }
    })
    let param = {
      product_id: state.productId,
      limit: state.search.limit,
      attribute_arr: attributeLocal,
      variants: state.result.lists
    }
    variantAPI.addVariantAttributes(param, results => {
      if (results.data.limit === 'fail') {
        resolve(false)
      } else {
        if (results.data.data) {
          commit('setProductVariants', results)
          resolve(results.data)
        } else {
          reject('error')
        }
      }
    })
  })
}

export const searchProductVariants = ({ dispatch }, param) => {
  dispatch('setSearchVariant', param).then(() => {
    dispatch('getProductVariants')
  })
}

export const setSearchVariant = ({ commit, state }, param) => {
  return new Promise((resolve, reject) => {
    let search = state.search
    if (param.key === 'sort') {
      search.sort = param.value.sort
      search.order = param.value.order
    } else if (param.key === 'page') {
      search.page = param.value
    }
    commit('setSearchVariant', search)
    resolve()
  })
}

export const setSearchVariantPage = ({ commit, state }, page) => {
  return new Promise((resolve, reject) => {
    commit('setSearchVariantPage', page)
    resolve()
  })
}

export const setProductVariant = ({ commit, state, dispatch }, param) => {
  return new Promise((resolve, reject) => {
    variantAPI.setProductVariant(param, results => {
      if (results.data.status === 'success') {
        dispatch('getProductVariants')
        resolve(true)
      } else {
        reject()
      }
    })
  })
}

export const deleteProductVariant = ({ commit, state, dispatch }, param) => {
  return new Promise((resolve, reject) => {
    variantAPI.deleteProductVariant(param, results => {
      if (results.data.status === 'success') {
        dispatch('getProductVariants')
        resolve(true)
      } else {
        reject()
      }
    })
  })
}

export const uploadProductVariantImageAPI = ({commit}, formData) => {
  return new Promise((resolve, reject) => {
    variantAPI.uploadProductVariantImage(formData, result => {
      resolve(result.data)
    })
  })
}

export const getProductVariantImagesAPI = ({ commit, dispatch }, productVariantId) => {
  return new Promise((resolve, reject) => {
    variantAPI.getProductVariantImages(productVariantId, result => {
      commit('setCurrentProductVariantImageLimit', result.data.data.imagesLimit)
      commit('setCurrentProductVariantImagesCount', result.data.data.product_variant_image.length)
      resolve(result.data.data.product_variant_image)
    })
  })
}

export const deleteProductVariantImageAPI = ({ commit, state, dispatch }, param) => {
  return new Promise((resolve, reject) => {
    variantAPI.deleteProductVariantImage(param, results => {
      if (results.data.status === 'success') {
        dispatch('getCurrentProductVariants')
        resolve(true)
      } else {
        reject()
      }
    })
  })
}

export const updateProductVariantImageAPI = ({commit}, formData) => {
  return new Promise((resolve, reject) => {
    variantAPI.updateProductVariantImage(formData, result => {
      resolve(result.data.data)
    })
  })
}

export const generateProductVariantsAPI = ({ commit, state }, attributes) => {
  return new Promise((resolve, reject) => {
    let attributeLocal = []
    attributes.forEach((element, index) => {
      if (element.attribute !== '' && element.value.length > 0) {
        attributeLocal[index] = element
      }
    })
    let param = {
      product_id: state.productId,
      limit: state.search.limit,
      attribute_arr: attributeLocal
    }
    variantAPI.generateProductVariantsAPI(param, results => {
      if (results.data.limit === 'fail') {
        resolve(false)
      } else {
        if (results.data.data) {
          commit('setProductVariants', results)
          resolve(true)
        } else {
          reject('error')
        }
      }
    })
  })
}

export const updateProductVariantListData = ({commit}, params) => {
  return new Promise((resolve, reject) => {
    variantAPI.updateProductVariantListData(params, result => {
      resolve(result.data)
    })
  })
}

export const deleteAllProductVariant = ({commit}, params) => {
  return new Promise((resolve, reject) => {
    variantAPI.deleteAllProductVariant(params, result => {
      resolve(result.data)
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/variants/actions.js